import { render, staticRenderFns } from "./CriarConta.vue?vue&type=template&id=0299dff1&scoped=true"
import script from "./CriarConta.vue?vue&type=script&lang=js"
export * from "./CriarConta.vue?vue&type=script&lang=js"
import style0 from "./CriarConta.vue?vue&type=style&index=0&id=0299dff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0299dff1",
  null
  
)

export default component.exports